export const Leaf = ({ attributes, children, leaf, showFormatting }) => {
  const { bold, code, italic, underline, subscript, superscript, backgroundColor, color, commentId, activeComment } = leaf;
  const {
    parent: { formatting },
  } = children.props;

  if (showFormatting) {
    let text = children.props.leaf.text.slice();
    text = text
      .replace(/ /g, '·') // Replace spaces with U+00B7
      .replace(/\t/g, '↑'); // Replace tabs with U+2191

    let updatedText = '';
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      if (char === '\n' || char === '\r') {
        updatedText += '↵' + char;
      } else {
        updatedText += char;
      }
    }

    // Each new child is a paragraph, so always insert paragraph in the end of each child
    text = updatedText + '¶';
    children.props.leaf.text = text;
  }

  let className = [];
  let customAttributes = { ...attributes };
  if (bold) {
    if (formatting?.format === 'paragraph' || formatting?.format === 'p') {
      className.push('xrp-body-bold');
    } else if (!formatting?.format) {
      // TODO: GABY-1538: Formatting is undefined in the leaf
      // formatting is undefined, fallback to body as default
      className.push('xrp-body-bold');
    } else {
      className.push('xrp-heading-bold');
    }
  }

  if (italic) {
    if (formatting?.format === 'paragraph' || formatting?.format === 'p') {
      className.push('xrp-body-italic');
    } else if (!formatting?.format) {
      // TODO: GABY-1538: Formatting is undefined in the leaf
      // formatting is undefined, fallback to body as default
      className.push('xrp-body-italic');
    } else {
      className.push('xrp-heading-italic');
    }
  }

  if (underline) {
    className.push('xrp-underline');
  }

  let Wrapper = code ? 'code' : 'span';

  const wrapperProps = {};
  if (subscript) {
    Wrapper = 'sub';
  }
  if (superscript) {
    Wrapper = 'sup';
  }
  if (backgroundColor || color) {
    wrapperProps.style = { backgroundColor, color };
  }
  if (commentId) {
    if (activeComment) {
      className.push('layout-leaf-comment-active');
    } else {
      className.push('layout-leaf-comment');
    }
    customAttributes = {
      ...customAttributes,
      'comment-id': commentId,
    };
  }
  return (
    <Wrapper {...customAttributes} className={className.join(' ')} {...wrapperProps}>
      {children}
    </Wrapper>
  );
};
